<!-- 共通ヘッダ（ロゴ） -->
<template>
  <header class="siteHeader">
    <img class="logo" src="../assets/images/logo.png">
  </header>
</template>
<script>
export default {
};
</script>
